import { render, staticRenderFns } from "./SyncLogTable.vue?vue&type=template&id=4baec916&scoped=true"
import script from "./SyncLogTable.vue?vue&type=script&lang=ts"
export * from "./SyncLogTable.vue?vue&type=script&lang=ts"
import style0 from "./SyncLogTable.vue?vue&type=style&index=0&id=4baec916&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4baec916",
  null
  
)

export default component.exports